import styled from 'styled-components';

import {Icon} from 'components/ui-kit/Icon';
import {Title} from 'components/ui-kit/Title';
import {breakpoint, colors} from 'theme';

export const MainContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    color: ${colors.black};
    min-height: calc(100vh - 120px);
`;

export const AuthImage = styled.div`
    display: none;
    flex: 1;
    background-color: ${colors.brandPrimary};
    overflow-x: hidden;

    img {
        width: 100%;
        max-width: 800px;
        min-width: 500px;
        -webkit-user-drag: none;
    }

    @media (min-width: ${breakpoint.tablet}) {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-end;
        align-items: center;
    }
`;

export const AuthContent = styled.div`
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background-color: ${colors.white};
    padding: 20px 20px;
    box-sizing: border-box;
    flex: 1;

    @media (min-width: ${breakpoint.desktop}) {
        padding: 40px 60px;
    }
`;

export const LanguageWrapper = styled.div`
    position: absolute;
    top: 20px;
    right: 10px;
`;

export const ServiceTitle = styled(Title)`
    //display: flex;
    //align-items: center;
    //justify-content: center;
    text-align: center;
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 0.5px;
    line-height: 40px;
    color: #fff;
    background-color: ${colors.brandPrimary};
    margin: 0;
    padding: 40px 100px;
    box-sizing: border-box;

    & > svg {
        vertical-align: middle;
    }

    path {
        fill: #fff;
    }
`;

export const CustomDatamatrixIcon = styled(Icon)`
    margin-right: 10px;
`;

export const AuthTitle = styled(Title)`
    display: flex;
    margin-bottom: 15px;
    font-weight: 500;

    @media (min-width: ${breakpoint.desktop}) {
        margin-top: 40px;
        margin-bottom: 100px;
    }
`;

export const AuthDescription = styled.p`
    text-align: center;
    font-weight: 400;
    font-size: 14px;

    @media (min-width: ${breakpoint.desktop}) {
        margin-bottom: 60px;
    }
`;

export const ButtonContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin: 20px auto;
    max-width: inherit;

    & > *:last-child {
        grid-column: -1 / 1;
    }
`;

export const Fields = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 5px;
`;

export const Field = styled.div`
    margin-bottom: 10px;

    &:last-of-type {
        margin-top: 20px;
    }
`;

export const CheckboxLabel = styled.div`
    font-size: 14px;
    color: ${colors.textPrimary};
`;
